module.exports = __webpack_public_path__ + "static/media/transporter-hero.61b73512.jpg";